function navigation() {

	jQuery('.js-menu-toggle').click(function() {
		jQuery('body').toggleClass('site-nav-active');
		jQuery(this).toggleClass('open');
	});
	
 	 jQuery( function ( $ ) {
	 	// Focus styles for menus when using keyboard navigation
		// Properly update the ARIA states on focus (keyboard) and mouse over events
		$( '[role="menubar"]' ).on( 'focus.aria  mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
			$( ev.currentTarget ).attr( 'aria-expanded', true );
		} );
		
		// Properly update the ARIA states on blur (keyboard) and mouse out events
		$( '[role="menubar"]' ).on( 'blur.aria  mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
			$( ev.currentTarget ).attr( 'aria-expanded', false );
		} );
	} );
	
	
	//Mobile Nav Expandable Children
/*
	jQuery("#primary-menu li.menu-item-has-children").each( function() {
		  var $children = jQuery(this).find('> a').text();
			jQuery(this).find('> a').after( jQuery("<button class='mobile sub-menu-toggle'>View Children of " + $children + "</botton>") );	
		});
	
	jQuery('.sub-menu-toggle').click(function() { 
		if ( jQuery(this).parents('li.menu-item-has-children').hasClass("active") ) { 
			jQuery(this).parents('li.menu-item-has-children').toggleClass('active');
		} else {
			jQuery('li.menu-item-has-children.active').removeClass('active');
			jQuery(this).parents('li.menu-item-has-children').toggleClass('active');
		}	
	});
*/
  
}

